import { ComponentStyleConfig } from '@chakra-ui/react';

const Radio: ComponentStyleConfig = {
  defaultProps: {
    colorScheme: 'radio',
  },
};

export default Radio;
